import React from "react"

export default function NotVideoDurationInput({ value, onChange, max = 60 }) {
  return (
    <div className="ai-targeting-form__field">
      <div className="ai-targeting-form__field-header">
        <div className="ai-targeting-form__field-icon ai-targeting-form__field-icon--blue">
          <i className="fas fa-clock"></i>
        </div>
        <label className="ai-targeting-form__field-label">Durée d'affichage</label>
      </div>
      <div className="ai-targeting-form__duration-input">
        <input
          type="number"
          min="0"
          max={max}
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value, 10) || 0)}
        />
        <span className="ai-targeting-form__duration-unit">secondes</span>
      </div>
      <div className="ai-targeting-form__field-hint">
        Durée d'affichage pour les images et fichiers PDF (max {max}s).
      </div>
    </div>
  )
}
